import { Grid, Typography } from "@mui/material";
import DeadlinesImage from "../../assets/deadlines.png";
import DeadlinesMobileImage from "../../assets/deadlines_mobile.png";
import useWindowDimensions from "../../helpers/window";

const Deadlines = () => {
  const { width } = useWindowDimensions();

  return (
    <div className="deadlines">
      <Grid container className="deadlines-container">
        <Grid item xs={12} lg={7} className="home-page_feature-image-container">
          <img
            src={width > 1400 ? DeadlinesImage : DeadlinesMobileImage}
            className="home-page_feature-image"
          />
        </Grid>
        <Grid item xs={12} lg={3} className="home-page_feature-text-container">
          <Typography
            variant="h2WhiteNoMargin"
            className="home-page_feature-header"
          >
            Task deadlines
          </Typography>
          <Typography
            variant="body1WhiteNoMargin"
            className="home-page_feature-text"
          >
            Add deadlines to keep track of your time sensitive tasks
          </Typography>
        </Grid>
        <Grid item xs={12} lg={2} />
      </Grid>
    </div>
  );
};

export default Deadlines;
